<div fxLayout="column" class="neq-dialog">
  <div *ngIf="message" [innerHTML]="message"></div>

  <ng-container *ngIf="entities">
    <ul>
      <li *ngFor="let entity of entities">
        {{ entity.entityLabel }}
        <ul>
          <li *ngFor="let rawMatCode of entity.rmCodes">
            {{ rawMatCode.rmCode }} {{ rawMatCode.rmLabel }}
          </li>
        </ul>
      </li>
    </ul>
  </ng-container>

  <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
    <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.ok' | translate}}" (click)="continue()"></button>
    <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.cancel' | translate}}" (click)="goBack()"></button>
  </div>
</div>
